import type { ConversationState } from '@cbm/types';

const copy: Record<ConversationState, string | null> = {
  ai_active: null,
  waiting_for_human: 'Έχει ειδοποιηθεί μέλος της ομάδας. Τα νέα μηνύματα θα αποθηκεύονται για εκείνον.',
  human_active: 'Αυτή τη συνομιλία τη χειρίζεται αυτή τη στιγμή άνθρωπος.',
  closed: 'Αυτή η συνομιλία έχει κλείσει.',
};

export function StatusBanner({ state }: { state: ConversationState }) {
  const text = copy[state];
  if (!text) {
    return null;
  }

  return <div className="cbm-status-banner">{text}</div>;
}
